<div #fieldConfigPop class="field-config-pop" style="width: 250px">
  <div class="field-config-pop-title">
    <div class="d-flex align-items-center">
      <ng-content select=".title"></ng-content>
    </div>
    <i class="far fa-times cursor-pointer close-icon" (click)="onHideSettings()"></i>
  </div>
  <div class="field-config-pop-content">
    <app-field-setting-form
      [form]="form"
      [roles]="roles"
      [isCustomField]="isCustomField"
      [isRequiredEditable]="isRequiredEditable"
      [isValueCustomizable]="isValueCustomizable"
      [isEditableGuestDataDictField]="isEditableGuestDataDictField"
      [isRoleEditable]="isRoleEditable"
      [disableCustomFont]="disableCustomFont"
      [prefillType]="prefillType"
      (role)="onRoleChange($event)"
    ></app-field-setting-form>
  </div>
</div>

<div
  #draggableElement
  ngDraggable
  [handle]="resizableElement"
  [bounds]="boundsRef"
  [inBounds]="inBounds"
  [scale]="zoomScale"
  (endOffset)="onMoveEnd($event)"
  class="resizeable field-placeholder-wrapper"
>
  <div
    class="field-placeholder d-flex align-items-end panzoom-exclude"
    #resizableElement
    ngResizable
    [scale]="zoomScale"
    [rzHandles]="resizableEdges"
    (rzStop)="onResizeStop()"
    (click)="onShowSettings()"
  >
    <div class="text-truncate panzoom-exclude field-label">
      <ng-content select=".label"></ng-content>
    </div>
    <i class="far fa-times-circle field-remove-btn" (click)="onRemove($event)"></i>
  </div>
</div>
